import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable()
export class AdminService {

  private sync = new Subject<string>();
  currentMessage = this.sync.asObservable();

  private closePopup = new Subject<void>();
  initiate = this.closePopup.asObservable();

  constructor() { }

  informSync(process: string) {
    this.sync.next(process)
  }

  informClose() {
    this.closePopup.next();
  }

}